import React, { useEffect, useState } from 'react'

import { CalendarCardWrapper } from 'components/Calendar/style'
import CalendlyLogo from 'assets/images/calendly-logo.png'
import GoogleCalendar from 'assets/images/google-calendar.png'
import outLook from 'assets/images/outlook.png'
import { CYCLR_CALENDAR } from 'config'
import { getRoleFromPath } from 'utils/helper'
import { useAuthentication } from 'utils/authentication'
import Button from 'components/Common/Button'
import ConnectedView from 'components/Calendar/Integrations/ConnectedView'

const Integrations = ({
  user,
  oAuthUrl,
  loadingStatus,
  userConnectors,
  handleDisconnect,
  getOAuthUrlAction,
  resetOAuthUrlAction,
  toolConnectionSuccessAction,
  getUserConnectorsAction,
  subscribeGoogleCalendarWebhookAction,
}) => {
  const [activeConnectingTool, setActiveConnectingTool] = useState(null)

  const handleCloseAuth = () => {
    if (activeConnectingTool === CYCLR_CALENDAR.GOOGLE_CALENDAR) {
      subscribeGoogleCalendarWebhookAction()
    }
    toolConnectionSuccessAction({ connectorName: activeConnectingTool })
    setActiveConnectingTool(null)
  }

  useAuthentication(oAuthUrl, getUserConnectorsAction, resetOAuthUrlAction, handleCloseAuth)

  useEffect(() => {
    getUserConnectorsAction()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const connectCalander = (calendar) => {
    setActiveConnectingTool(calendar)
    getOAuthUrlAction({ calendar, targetOrigin: window.location.href })
  }
  const userRole = getRoleFromPath()

  const openCalendlyEventUrl = (eventUrl) => {
    window.open(eventUrl, '_blank')
  }
  const connectorAuthenticationHandler = (connectorName) => {
    return userConnectors?.find((con) => con.name === connectorName)?.authenticated
  }

  return (
    <>
      <CalendarCardWrapper>
        <div className="card">
          <div className="bg-blue-light imgCard">
            <img src={CalendlyLogo} alt="calendly" className="imgCardContent" />
          </div>
          <div className="cardBody">
            <h4 className="cardBodyHeading">Calendly</h4>
            <div className="cardBodyContent">
              {connectorAuthenticationHandler(CYCLR_CALENDAR.CALENDLY) &&
              !user.calendlyEventsUrl ? (
                <ConnectedView handleDisconnect={() => handleDisconnect(CYCLR_CALENDAR.CALENDLY)} />
              ) : connectorAuthenticationHandler(CYCLR_CALENDAR.CALENDLY) &&
                userRole !== 'owner' &&
                user &&
                user.calendlyEventsUrl ? (
                <div className="cardBodyButton">
                  <Button
                    variant="secondary"
                    onClick={() => openCalendlyEventUrl(user?.calendlyEventsUrl)}
                    label="ADJUST AVAILABILITY"
                    className="w-full"
                  />
                </div>
              ) : (
                <div className="cardBodyButton">
                  <Button
                    variant="secondary"
                    label="Connect"
                    status={loadingStatus.calendlyLoadingStatus}
                    onClick={() => connectCalander(CYCLR_CALENDAR.CALENDLY)}
                    className="w-full"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </CalendarCardWrapper>

      <CalendarCardWrapper>
        <div className="card">
          <div className="bg-cream-dark imgCard">
            <img src={GoogleCalendar} alt="Google calendar" className="imgCardContent" />
          </div>
          <div className="cardBody">
            <h4 className="cardBodyHeading">Google Calendar</h4>

            <div className="cardBodyContent">
              {connectorAuthenticationHandler(CYCLR_CALENDAR.GOOGLE_CALENDAR) ? (
                <ConnectedView
                  handleDisconnect={() => handleDisconnect(CYCLR_CALENDAR.GOOGLE_CALENDAR)}
                />
              ) : (
                <div className="cardBodyButton">
                  <Button
                    variant="secondary"
                    onClick={() => connectCalander(CYCLR_CALENDAR.GOOGLE_CALENDAR)}
                    label="Connect"
                    status={loadingStatus.googleLoadingStatus}
                    className="w-full"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </CalendarCardWrapper>

      <CalendarCardWrapper>
        <div className="card">
          <div className="bg-blue-darker imgCard">
            <img src={outLook} alt="outlook calendar" className="imgCardContent" />
          </div>
          <div className="cardBody">
            <h4 className="cardBodyHeading">Microsoft Office 365 Outlook</h4>

            <div className="cardBodyContent">
              {connectorAuthenticationHandler(CYCLR_CALENDAR.MICROSOFT_OFFICE_365) ? (
                <ConnectedView
                  handleDisconnect={() => handleDisconnect(CYCLR_CALENDAR.MICROSOFT_OFFICE_365)}
                />
              ) : (
                <div className="cardBodyButton">
                  <Button
                    variant="secondary"
                    // loading={outlookOAuthLoading}
                    status={loadingStatus.outLookLoadingStatus}
                    onClick={() => connectCalander(CYCLR_CALENDAR.MICROSOFT_OFFICE_365)}
                    label="Connect"
                    className="w-full"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </CalendarCardWrapper>
    </>
  )
}
Integrations.defaultProps = {
  user: {},
  oAuthUrl: '',
  loadingStatus: {},
  userConnectors: [],
  handleDisconnect: () => {},
  toolConnectionSuccessAction: () => {},
  resetOAuthUrlAction: () => {},
}

export default Integrations
